import React from "react"
import classNames from "classnames"
import { Range } from "rc-slider"

export default function FieldRange({
  label,
  labelClassname,
  field,
  form,
  marks,
  depth,
  readOnly,
  disabled,
  style = {},
  className = "ml-6 mb-5",
  ...props
}) {
  const values = Object.values(marks).map((mark) => mark.id)
  const min = Math.min(...values)
  const max = Math.max(...values)
  return (
    <div className="d-flex flex-column overflow-x-visible">
      {label && (
        <label
          className={classNames(
            "font-weight-semibold mb-3 h3 text-uppercase",
            labelClassname
          )}
        >
          {label}
        </label>
      )}
      <Range
        value={field.value === null ? [min, max] : field.value}
        min={min}
        max={max}
        className={className}
        marks={marks}
        step={null}
        onChange={(value) => form.setFieldValue(field.name, value)}
        defaultValue={[min, max]}
        style={{ width: "90%", ...style }}
        trackStyle={[{ backgroundColor: "var(--primary)" }]}
        handleStyle={[
          {
            border: "2px solid var(--primary)",
            height: 16,
            width: 16,
            marginTop: -6,
            cursor: "pointer",
          },
          {
            border: "2px solid var(--primary)",
            height: 16,
            width: 16,
            marginTop: -6,
            cursor: "pointer",
          },
        ]}
        activeDotStyle={{
          borderColor: "transparent",
          backgroundColor: "var(--primary)",
        }}
        allowCross={false}
        disabled={readOnly || disabled}
      />
    </div>
  )
}
